import { render } from "./AlertPopup.vue?vue&type=template&id=ba35464e&ts=true"
import script from "./AlertPopup.vue?vue&type=script&lang=ts"
export * from "./AlertPopup.vue?vue&type=script&lang=ts"

import "./AlertPopup.vue?vue&type=style&index=0&id=ba35464e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__